// testsExecutionService.typedef.js

import { FAILED, SUCCESS } from '../constants';
import { requestWithOptions } from './helper';

const basePath = import.meta.env.REACT_APP_API_ENDPOINT_TESTS_EXECUTION || '/';

const affectedTestCaseTags = ['SUB_NOT_RECOG'];
const affectedApiTags = ['PHONE_NUM_INFO', 'EAP_AKA_AUTH'];

// TODO Resolve failed responses
// This logic should be removed after DEMO. This should come from the backend
const parseFailedResponses = response => {
  if (
    response.status === FAILED &&
    affectedTestCaseTags.includes(response.test_case_tag) &&
    affectedApiTags.includes(response.api_tag) &&
    response?.invocations?.at(-1)?.response
  ) {
    const invocation = response.invocations.at(-1);
    const parsedResponse = JSON.parse(invocation.response);

    if (parsedResponse?.data?.error_msg === 'IMSI not found') {
      return {
        ...response,
        status: SUCCESS,
      };
    }

    return response;
  }

  return response;
};

export const createTestsApiExecution = async (payload: any) => {
  const options = {
    method: 'POST',
    body: JSON.stringify(payload),
  };
  const path = `${basePath}/tests/apis`;

  const result = await requestWithOptions(path, options);
  return result;
};

export const getTestsApiExecution = async (testId: string) => {
  const options = { method: 'GET' };
  const path = new URL(`${basePath}/tests/apis/${testId}`);
  const response = await requestWithOptions(path, options);

  const replacedFailedResponses = parseFailedResponses(response);

  return replacedFailedResponses;
};

export const createTestsUsecaseExecution = payload => {
  const options = {
    method: 'POST',
    body: JSON.stringify(payload),
  };
  const path = `${basePath}/tests/usecases`;

  return requestWithOptions(path, options);
};

export const getTestsUsecaseExecutionById = async testId => {
  const options = { method: 'GET' };
  const path = new URL(`${basePath}/tests/usecases/${testId}`);

  const response = await requestWithOptions(path, options);
  return {
    ...response,
  };
};

export const cancelTestsUsecaseExecution = async payload => {
  const options = { method: 'POST', body: JSON.stringify(payload) };
  const path = new URL(`${basePath}/tests/usecases/cancel`);

  return requestWithOptions(path, options);
};
